// Customizable Area Start
import { IBlock } from "../../../framework/src/IBlock";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { Message } from "../../../framework/src/Message";
import { allMessagesIcon } from "./assets";
import { conversationType } from "./constants";
import { ChatNavIcon } from "../../dashboard/src/assets";
import React, { createRef } from "react";
import { baseURL } from "../../../framework/src/config";
import { getErrorMessage } from "../../../components/src/CommonFunctions";

export const configJSON = require("./config");

// Import the new message variables system
import { 
  MessageVariable, 
  DEFAULT_MESSAGE_VARIABLES, 
  MessageVariableProcessor,
  MessageVariableContext
} from '../../utilities/src/MessageVariables';
import { 
  processMessageVariables, 
  MessageContext as SimpleMessageContext 
} from '../../utilities/src/MessageVariableProcessor';

// Legacy automationsData for backward compatibility
const automationsData = [
  {
    name: "Contact First Name",
    type: " :contact_first_name: ",
  },
  {
    name: "Contact Full Name",
    type: " :contact_full_name: ",
  },
  {
    name: "Business Name",
    type: " :business_name: ",
  },
  {
    name: "Business Phone",
    type: " :business_phone: ",
  },
  {
    name: "Review Link",
    type: " :review_link: ",
  },
  {
    name: "Friend Invite Link",
    type: " :friend_invite_link: ",
  },
  {
    name: "Home Feed Highlight",
    type: " :new_post_highlight: ",
  },
  {
    name: "Invite Contact to Post",
    type: " :create_post_invite: ",
  },
];

export interface Props {
  navigation: any;
  id: string;
  classes?: any;
  
}

interface S {
  chatType: string;
  chatCircle: any;
  text: any;
  chat: any;
  directPost: any;
  allMessages: any;
  allChatsArray: any;
  conversations: any;
  uniqueDates: any;
  userFolders: any;
  isNewMessage: boolean;
  userContacts: any;
  showContcatCard: boolean;
  selectedConversation: any;
  selectedContact: any;
  newMessage: string;
  response: any;
  anchorEll: any;
  userItem: any;
  teammates: any;
  teammatesModal: boolean;
  userDetails: any;
  automationModal: any;
  automationContent: any;
  newContactModal: boolean;
  showAlert: boolean;
  errorAlertMessage: boolean;
  showSuccess: any;
  messageOptionsPopover: any;
  conversationNewData: any;
  conversationDataMain: any;
  chatTypeAPI: string;
  autoamtionFilterData: any;
  automationSearchQuery: string;
  messageSearchQuery: string;
  chatSelectedContact: any;
  isLoading: boolean;
  openInfoModal: boolean;
  newOrOldUserSelected: boolean;
  tempAddingNewContact: any;
  isLeftSideVisibleForMobileview: boolean;
  isCenterSideVisibleForMobileView: boolean;
  isRightSideVisibleForMobileView: boolean;
  isDocCameraAutoVisible: boolean;
  addNewMessageMobile: boolean;
  createNewContactMobile: boolean;
  isLoaderShow: boolean;
  selectedConversationForPopover: any;
  filterAnchorEl: any;
  selectedFilterName: string;
  // New message variables state
  customMessageVariables: MessageVariable[];
  messageVariableContext: MessageVariableContext;
  messageProcessor: MessageVariableProcessor | null;
  // Local input state for contact search field in New message modal
  contactSearchQuery?: string;
  editFolderModal: boolean;
  editFolderName: string;
  isAddingContact: boolean;
  callMenuModal: any;
  hasSelectedAtLeastOnce:any;
  isFetchingChat:any;
  hoveredMessageKey: string;
  reactionPickerAnchorEl: any;
  reactionPickerMessageKey: string;
  messageReactions: { [key: string]: string };
  reactionPickerPosition: { top: number; left: number } | null;
  searchText: string;
  searchUsers: any[];
  searchCustomers: any[];
  conversationIdNew: any;
  selectedSearchUser: any;
  mobileKeyboardOffset: number;
  mobileTopBarHeight: number;
  mobileContactHeaderHeight: number;

}
interface SS {
  id: any;
}
export default class MessagesController extends BlockComponent<Props, S, SS> {
  getUserChatsApiId: any = "";
  getFoldersApiId: any = "";
  createFoldersApiId: any = "";
  getContactsApiId: any = "";
  getDirectPostApiId: any = "";
  getDirectPostDetailApiId: any = "";
  newMessageApiId: any = "";
  newConversationApiId: any = "";
  deleteFolderApiId: any = "";
  getTeamMatesApiId: any = "";
  updateFolderApiId: any = "";
  userDetailsApiCallId: any = "";
  addNewContactsApiCallId: any = "";
  addNewChatContactsApiCallId: string= "";
  filterMessagesApiCallId: any = "";
  cameraAttachmentsApiCallId: any = "";
  getConversationUserId: any = "";
  createConversationApiCallId: any = "";
  searchUsersApiCallId:any = "";
  searchCustomersApiCallId:any = "";
  silentRefreshApiId: any = "";
  refreshConversationMessagesApiId: any = "";
  lastMessageRef: any = createRef<HTMLDivElement>();
  messagesContainerRef: React.RefObject<HTMLDivElement>;
  messagesEndRef: React.RefObject<HTMLDivElement>;
  chatSectionRef = React.createRef<HTMLDivElement>();
  chatSocket: WebSocket | null = null;
  chatSocketReconnectTimer: ReturnType<typeof setTimeout> | null = null;
  isChatSocketSubscribed: boolean = false;
  constructor(props: Props) {
    super(props);
    this.handleClosePopOver = this.handleClosePopOver.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.receive = this.receive.bind(this);
    this.getUserChats = this.getUserChats.bind(this);
    this.messagesContainerRef = React.createRef<HTMLDivElement>();
    this.messagesEndRef = React.createRef<HTMLDivElement>();
    this.chatSectionRef = React.createRef<HTMLDivElement>();

    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.NavigationMobileData),
      getName(MessageEnum.NavigationMessage),
      getName(MessageEnum.NavigationTargetMessage),
      getName(MessageEnum.NavigationPropsMessage)
    ];

    this.state = {
      chatType: "All Messages",
      chatTypeAPI: "All Messages",
      chatCircle: allMessagesIcon,
      text: {},
      uniqueDates: [],
      allMessages: {},
      chat: {},
      directPost: {},
      conversations: {},
      userFolders: [],
      isNewMessage: false,
      userContacts: [],
      showContcatCard: false,
      selectedConversation: {},
      selectedContact: {},
      allChatsArray: [],
      newMessage: "",
      response: [],
      anchorEll: null,
      userItem: {},
      teammates: [],
      teammatesModal: false,
      automationModal: null,
      automationContent: automationsData,
      newContactModal: false,
      showAlert: false,
      errorAlertMessage: false,
      showSuccess: "",
      userDetails: {
        attributes: {
          first_name: "",
          last_name: "",
        },
      },
      messageOptionsPopover: null,
      conversationNewData: [],
      conversationDataMain: [],
      autoamtionFilterData: automationsData,
      automationSearchQuery: "",
      messageSearchQuery: "",
      chatSelectedContact: [],
      isLoading: false,
      openInfoModal: false,
      newOrOldUserSelected: false,
      tempAddingNewContact: {},
      isLeftSideVisibleForMobileview: false,
      isCenterSideVisibleForMobileView: true,
      isRightSideVisibleForMobileView: false,
      isDocCameraAutoVisible: false,
      addNewMessageMobile: false,
      createNewContactMobile: false,
      isLoaderShow: false,
      selectedConversationForPopover: {},
      filterAnchorEl: null,
      selectedFilterName: "All Messages",
      callMenuModal:null,
      // Initialize message variables state
      customMessageVariables: [],
      messageVariableContext: {
        contact: undefined,
        business: undefined,
        system: {
          current_user_id: '',
          current_business_id: '',
          timestamp: new Date().toISOString()
        }
      },
      messageProcessor: null,
      contactSearchQuery: "",
      editFolderModal: false,
      editFolderName: "",
      isAddingContact: false,
      hasSelectedAtLeastOnce:false,
      isFetchingChat:false,
      hoveredMessageKey: "",
      reactionPickerAnchorEl: null,
      reactionPickerMessageKey: "",
      messageReactions: {},
      reactionPickerPosition: null,
      searchText: "",
      searchUsers: [] as any[],
      searchCustomers: [],
      conversationIdNew:'',
      selectedSearchUser:{},
      mobileKeyboardOffset: 0,
      // Default matches NavigationMenuMobile's expanded `minHeight` (56px) so
      // there's no visible overlap flash before the real height is measured.
      mobileTopBarHeight: 33,
      mobileContactHeaderHeight: 87,
      // UI toggle state
      // useNewMessageUI: true,
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async receive(from: string, message: Message) {
    console.log("========== RECEIVE ==========");
    console.log("Message ID:", message.id);
    console.log("Expected:", getName(MessageEnum.RestAPIResponceMessage));
    console.log("Full Message:", message);
  
    const messageType = getName(MessageEnum.RestAPIResponceMessage);
  
    if (messageType === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
  
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
  
      const error = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );
  
      console.log("apiRequestCallId:", apiRequestCallId);
      console.log("searchUsersApiCallId:", this.searchUsersApiCallId);
      console.log("responseJson:", responseJson);
      console.log("error:", error);
  
      this.handleReceive(apiRequestCallId, responseJson);
    }
  }

  handleReceive(apiRequestCallId: any, responseJson: any) {
    if (apiRequestCallId === this.getUserChatsApiId) {
      
      this.handleChatResponse(responseJson);
    }
    if (apiRequestCallId === this.silentRefreshApiId) {
      // Silently update conversation list without showing loader
      this.handleChatResponseSilently(responseJson);
    }
    if (apiRequestCallId === this.refreshConversationMessagesApiId) {

      const messages = responseJson.messages || [];
      const mergedChats = this.mergeChatMessages(messages);

      this.setState(
        {
          chatSelectedContact: mergedChats,
        },
        () => {
          this.scrollToBottom("smooth");
        }
      );
    }

    if (apiRequestCallId === this.createConversationApiCallId) {

      this.setState({ conversationIdNew: responseJson.conversation.id });

      this.getConversation(responseJson);

      this.handleInfoModalChange();
    }

    if (apiRequestCallId === this.getFoldersApiId) {
      this.getTeammates();
      this.setState({ userFolders: responseJson.data });
    }
    if (apiRequestCallId === this.getTeamMatesApiId) {
      this.getUserDetails();
      this.setState({ teammates: responseJson.data });
    }
    if (apiRequestCallId === this.createFoldersApiId) {
      this.getFolders();
    }
    if (apiRequestCallId === this.getContactsApiId) {
      this.handleGetContactResponse(responseJson);
    }
    if (apiRequestCallId === this.newConversationApiId) {
      this.sendNewMessage();
    }
    if (apiRequestCallId === this.newMessageApiId) {
      this.syncConversationIdFromSendResponse(responseJson);
      this.setState({ newMessage: ""});
      // Keep optimistic message in place; avoid full reload/flicker on every send.
      this.refreshConversationMessages();
    }
    if (apiRequestCallId === this.deleteFolderApiId) {
      this.handleClosePopOver();
      this.getFolders();
    }
    if (apiRequestCallId === this.updateFolderApiId) {
      this.closeModal();
      this.handleClosePopOver();
      this.getFolders();
      this.closeEditFolderModal();
    }
    if (apiRequestCallId === this.userDetailsApiCallId) {
      this.setState({ userDetails: responseJson.account.data });
    }

    if (apiRequestCallId === this.addNewContactsApiCallId) {
      this.handleAddNewContactResponse(responseJson);
    }

    if (apiRequestCallId === this.filterMessagesApiCallId) {
      this.handleFilterApiResponse(responseJson);
    }
    if (apiRequestCallId === this.searchUsersApiCallId) {
      console.log("responseJson123321", responseJson);
    
      this.setState({
        searchUsers: responseJson.users || [],
      });
    }
if (apiRequestCallId === this.searchCustomersApiCallId) {
  console.log("Customers API Response", responseJson);

  this.setState(
    {
      searchCustomers: responseJson.users || [],
    },
    () => {
      console.log(
        "Updated searchCustomers",
        this.state.searchCustomers
      );
    }
  );
}

   if (apiRequestCallId === this.getConversationUserId) {

  const messages = responseJson.messages || [];
  const mergedChats = this.mergeChatMessages(messages);

  this.setState(
    {
      chatSelectedContact: mergedChats,
      isLoading: false,
      hasSelectedAtLeastOnce: true,
      isFetchingChat: false,
      openInfoModal: true,
    },
    () => {
      setTimeout(() => {
        this.scrollToBottom("auto");
      }, 10);
    }
  );
}
    if(apiRequestCallId === this.addNewChatContactsApiCallId){
      const apiError = responseJson?.errors?.[0] || responseJson?.error;
      if (apiError) {
        this.setState({
          showAlert: true,
          errorAlertMessage: true,
          showSuccess: getErrorMessage(apiError),
          isAddingContact: false,
        });
        setTimeout(() => this.setState({ showAlert: false }), 3000);
      } else {
        this.setState({
          newContactModal: false,
          errorAlertMessage: false,
          showAlert: true,
          showSuccess: "Contact Added Successfully! ",
          isAddingContact: false,
        });
        setTimeout(() => this.setState({ showAlert: false }), 3000);
        this.filterMessages('chat_contacts')
      }
    }
  }
  
  handleFilterApiResponse = (responseJson: any) => {
    
    let data;
    if (this.state.chatTypeAPI === "direct_post_contacts") {
      data = responseJson.direct_post_contacts.data;
    } else {
      data = responseJson.data;
    }
    
    let pinSortedData =  data.sort((a: any, b: any) => {
      return b.attributes.pin_conversation - a.attributes.pin_conversation;
    });
    this.setState({ conversationNewData: this.groupAndSortByDateChat(data), conversationDataMain: data, isLoaderShow: false });

    if(this.state.isNewMessage && Object.keys(this.state.tempAddingNewContact).length != 0){
      this.setState({
        selectedConversation: data.find((item: any) => item.id === this.state.tempAddingNewContact.attributes.id),
        isNewMessage: false,
        newOrOldUserSelected: true})
    }
    
  };

  // `delivered_via_sms` on a just-sent message only reflects the carrier's
  // delivery webhook, which lands a moment *after* the message is created —
  // so a fresh fetch right after sending can briefly report the old/default
  // channel (imsg/blue) for a message that will settle as sms/green once the
  // webhook catches up. For a sender message younger than the grace window,
  // keep it on the same channel as the message right before it instead of
  // flashing the wrong color and correcting itself a moment (or a reload) later.
  resolveMessageDevice = (msg: any, previousDevice: string | undefined): string => {
    const confirmedDevice = msg.delivered_via_sms ? "sms" : "imsg";
    const isSenderMessage = msg.sender_type !== "BxBlockCustomer::Customer";
    // Math.abs, not a plain forward-only diff — a server clock running even
    // slightly ahead of the client makes `created_at` land in the "future",
    // and a signed diff would permanently disqualify it as "recent", letting
    // the not-yet-confirmed blue flash through with no smoothing at all.
    const ageMs = Math.abs(Date.now() - new Date(msg.created_at).getTime());
    const isRecentSend = isSenderMessage && ageMs < 20000;

    if (!isRecentSend) {
      return confirmedDevice;
    }
    if (previousDevice) {
      return previousDevice;
    }
    // No prior message to match yet — e.g. the very first message in a
    // brand new conversation. This business's conversations are
    // overwhelmingly sms, so default to that instead of flashing blue.
    return confirmedDevice === "imsg" ? "sms" : confirmedDevice;
  };

  mergeChatMessages = (messages: any[]): any[] => {
    const sorted = [...messages].sort(
      (a: any, b: any) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
    );

    let runningDevice: string | undefined;
    return sorted.map((msg: any) => {
      const device = this.resolveMessageDevice(msg, runningDevice);
      runningDevice = device;
      return {
        ...msg,
        body: msg.content,
        device,
        _direction:
          msg.sender_type === "BxBlockCustomer::Customer" ? "receiver" : "sender",
      };
    });
  };

  scrollToBottom = (behavior: 'auto' | 'smooth' = 'auto') => {
    // Both the desktop and mobile layouts render their own copy of this chat
    // area (CSS toggles which one is visible per breakpoint), so document.getElementById
    // would only ever hit the first (desktop) copy. Scroll every copy so whichever
    // one is actually visible ends up showing the latest message.
    const containers = document.querySelectorAll(".chat-scroll-container");
    const anchors = document.querySelectorAll(".messages-anchor");

    containers.forEach((container) => {
      container.scrollTop = container.scrollHeight;
    });

    anchors.forEach((anchor) => {
      anchor.scrollIntoView({ behavior: behavior, block: "end" });
    });
  };
  handleInfoModalChange = () => {
    this.setState(prevState => ({...prevState, openInfoModal: !prevState.openInfoModal}))
  }

  formatDateTime(dateStr: string | undefined): string {
    if(!dateStr){
      return "N/A"
    }
    const date = new Date(dateStr);
    
    // Get today's date and yesterday's date
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    // Function to format the time to AM/PM
    const formatTime = (date: Date): string => {
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12; // Convert to 12-hour format
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
        return `${formattedHours}:${formattedMinutes} ${ampm}`;
    };

    // Check if the date is today or yesterday
    if (date.toDateString() === today.toDateString()) {
        return `Today at ${formatTime(date)}`;
    } else if (date.toDateString() === yesterday.toDateString()) {
        return `Yesterday at ${formatTime(date)}`;
    } else {
        // Format the date as MM/DD/YYYY
        const formattedDate = date.toLocaleDateString('en-US');
        return `${formattedDate} at ${formatTime(date)}`;
    }
}

handleMessageOptions = (
  event: React.MouseEvent<HTMLElement>,
  contact: any
) => {
  event.stopPropagation();

  console.log("Selected Contact:", contact);

  this.setState({
    messageOptionsPopover: event.currentTarget,
    selectedConversationForPopover: contact,
  });
};
  handleMessagePopoverReply = (e:any) => {
    this.changeTopNavigation(this.state.chatType);
    e.stopPropagation();
    this.setState({isCenterSideVisibleForMobileView:false, isRightSideVisibleForMobileView: true, messageOptionsPopover: null, selectedConversation: this.state.selectedConversationForPopover });
  }

  handleMessagePopoverClose = (e: any) => {
    e.stopPropagation()
    this.setState({ messageOptionsPopover: null, selectedConversationForPopover: null });
  };

  handleAddNewContactResponse(responseJson: any) {
    if (responseJson.data) {
      // Add the new contact to the existing conversation data
      const newContact = responseJson.data;
      
      // Check if contact already exists to prevent duplicates
      const existingContactIndex = this.state.conversationDataMain.findIndex(
        (contact: any) => contact.id === newContact.id
      );
      
      let updatedConversationDataMain;
      if (existingContactIndex === -1) {
        // Contact doesn't exist, add it
        updatedConversationDataMain = [...this.state.conversationDataMain, newContact];
      } else {
        // Contact exists, update it
        updatedConversationDataMain = [...this.state.conversationDataMain];
        updatedConversationDataMain[existingContactIndex] = newContact;
      }
      
      const sortedContacts = this.groupAndSortByDateChat(updatedConversationDataMain);
      
      this.setState({
        newContactModal: false,
        errorAlertMessage: false,
        showAlert: true,
        showSuccess: "Contact Added Successfully! ",
        selectedContact: newContact,
        isNewMessage: true,
        selectedConversation: newContact,
        conversationNewData: sortedContacts,
        conversationDataMain: updatedConversationDataMain,
        isAddingContact: false
      });
    } else {
      const apiError = responseJson.errors?.[0] || responseJson.error;
      const errorMessage = apiError
        ? getErrorMessage(apiError)
        : "Something went wrong!";
      this.setState({
        showAlert: true,
        errorAlertMessage: true,
        showSuccess: errorMessage,
        isAddingContact: false
      });
    }
    setTimeout(() => this.setState({ showAlert: false }), 3000);
  }

  handleGetContactResponse(responseJson: any) {
    this.setState({ userContacts: responseJson.data, showContcatCard: true });
  }

  handleAutomationItemClick(item: any) {
    // Insert the variable placeholder as-is (e.g., :contact_first_name:)
    // Variables will be replaced with actual values when the message is sent
    // This allows bulk messages to multiple contacts, where each recipient 
    // receives the message with their own information where the variable was placed
    this.setState({
      newMessage: this.state.newMessage + item.type,
      automationModal: null,
    });
  }

  // Function to remove duplicate contacts based on ID and type
  removeDuplicateContacts = (contacts: any[]) => {
    const seen = new Map();
    const duplicatesRemoved: string[] = [];
    
    const result = contacts.filter(contact => {
      const contactId = contact.id;
      const contactType = contact.attributes?.type || contact.type;
      const contactName = `${contact.attributes?.first_name || ''} ${contact.attributes?.last_name || ''}`.trim();
      
      if (seen.has(contactId)) {
        const existingContact = seen.get(contactId);
        const existingType = existingContact.attributes?.type || existingContact.type;
        
        // Priority: SmsContact > ChatContact
        if (contactType === 'SmsContact' && existingType === 'ChatContact') {
          // Replace ChatContact with SmsContact
          duplicatesRemoved.push(`Replaced ChatContact with SmsContact for ${contactName} (ID: ${contactId})`);
          seen.set(contactId, contact);
          return true;
        } else if (contactType === 'ChatContact' && existingType === 'SmsContact') {
          // Keep existing SmsContact, skip this ChatContact
          duplicatesRemoved.push(`Removed duplicate ChatContact for ${contactName} (ID: ${contactId})`);
          return false;
        } else {
          // Same type or other types, keep first occurrence
          duplicatesRemoved.push(`Removed duplicate ${contactType} for ${contactName} (ID: ${contactId})`);
          return false;
        }
      } else {
        seen.set(contactId, contact);
        return true;
      }
    });
    
    return result;
  };

  searchUsersApi = async (query: string) => {
    const header = {
      "Content-Type": "application/json",
      Accept: "application/json",
      token: localStorage.getItem("authToken"),
    };
  
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
  
    this.searchUsersApiCallId = requestMessage.messageId;
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.searchUsersEndPoint}?query=${encodeURIComponent(
        query
      )}&page=1&per_page=20`
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );
  
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  searchCustomersApi = (query: string) => {
    const header = {
      "Content-Type": "application/json",
      Accept: "application/json",
      token: localStorage.getItem("authToken"),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.searchCustomersApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.searchCustomersEndPoint}?query=${encodeURIComponent(query)}`
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  // Method to clean up existing duplicates in the current conversation data
  cleanupDuplicateContacts = () => {
    const originalCount = this.state.conversationDataMain.length;
    const uniqueData = this.removeDuplicateContacts(this.state.conversationDataMain);
    const sortedContacts = this.groupAndSortByDateChat(uniqueData);
    
    this.setState({
      conversationNewData: sortedContacts,
      conversationDataMain: uniqueData
    });
    
  };

handleSearchUserClick = (item: any, isCustomer: boolean = false) => {
  const selectedSearchUser = {
    first_name: isCustomer
      ? item.first_name
      : item.attributes.first_name,
    last_name: isCustomer
      ? item.last_name
      : item.attributes.last_name,
    full_name: isCustomer
      ? `${item.first_name || ""} ${item.last_name || ""}`.trim()
      : item.attributes.full_name,
    phone: isCustomer
      ? item.phone
      : `+${item.attributes.country_code} ${item.attributes.phone_number}`,
    profile_pic: isCustomer
      ? item.profile_pic
      : item.attributes.profile_pic,
  };

  this.setState(
    {
      searchText: "",
      searchUsers: [],
      searchCustomers: [],
      selectedSearchUser,
    },
    () => {
      this.createConversationNewAPI(item, isCustomer);
    }
  );
};
//   handleSearchUserClick = (item: any, isCustomer: boolean = false) => {
//   this.setState(
//     {
//       searchText: "",
//       searchUsers: [],
//       searchCustomers: [],
      
//     },
//     () => {
//       this.createConversationNewAPI(item, isCustomer);
//     }
//   );
// };

  createConversationNewAPI = (item: any, isCustomer: boolean = false) => {
  const header = {
    "Content-Type": "application/json",
    Accept: "application/json",
    token: localStorage.getItem("authToken"),
  };

  const requestMessage = new Message(
    getName(MessageEnum.RestAPIRequestMessage)
  );

  this.createConversationApiCallId = requestMessage.messageId;

  requestMessage.addData(
    getName(MessageEnum.RestAPIResponceEndPointMessage),
    configJSON.createConversationNewAPIEndPoint // bx_block_chat/conversations
  );

  requestMessage.addData(
    getName(MessageEnum.RestAPIRequestHeaderMessage),
    JSON.stringify(header)
  );

  requestMessage.addData(
    getName(MessageEnum.RestAPIRequestMethodMessage),
    "POST"
  );

  requestMessage.addData(
    getName(MessageEnum.RestAPIRequestBodyMessage),
    JSON.stringify({
      participant_ids: [item.id],
    })
  );

  runEngine.sendMessage(requestMessage.id, requestMessage);
};

groupAndSortByDateChat = (contacts: any[]) => {
  // Remove duplicates first
  const uniqueContacts = this.removeDuplicateContacts(contacts);

  const groupedContacts: Record<string, any[]> = {};

  uniqueContacts.forEach((contact) => {
    // Use last message date, otherwise conversation creation date
    const interactionDate =
      contact.last_message?.created_at || contact.created_at;

    const date = interactionDate
      ? interactionDate.split("T")[0]
      : "2012-12-12";

    if (!groupedContacts[date]) {
      groupedContacts[date] = [];
    }

    groupedContacts[date].push(contact);
  });

  const sortedGroups = Object.entries(groupedContacts)
    .map(([date, group]) => ({
      date,
      contacts: group.sort((a: any, b: any) => {
        const dateA = new Date(
          a.last_message?.created_at || a.created_at
        ).getTime();

        const dateB = new Date(
          b.last_message?.created_at || b.created_at
        ).getTime();

        return dateB - dateA;
      }),
    }))
    .sort((a, b) => {
      return (
        new Date(b.date).getTime() -
        new Date(a.date).getTime()
      );
    });

  return sortedGroups;
};

handleChatResponse(responseJson: any) {

  const newData = responseJson?.conversations || [];

  const uniqueData = this.removeDuplicateContacts(newData);

  const sortedContacts = this.groupAndSortByDateChat(uniqueData);

  this.setState({
    conversationNewData: sortedContacts,
    conversationDataMain: uniqueData,
    isLoaderShow: false,
  });

  const selectedConversationId = String(
    this.getSelectedConversationId() || ""
  );

  const selectedConversationData = uniqueData.find(
    (contact: any) =>
      String(contact.id) ===
      String(this.state.selectedConversation?.id)
  );

  const latestConversationId = String(
    selectedConversationData?.id || ""
  );

  if (
    selectedConversationData &&
    latestConversationId &&
    selectedConversationId &&
    latestConversationId !== selectedConversationId
  ) {
    this.updateSelectedConversationId(
      latestConversationId,
      false
    );
  }
}

  handleChatResponseSilently(responseJson: any) {
    // Update conversation list silently without showing loader (like WhatsApp Web)
    const newData = [
      ...responseJson.text_contacts.data,
      ...responseJson?.direct_post_contacts,
    ];
    
    // Remove duplicates from the API response data
    const uniqueData = this.removeDuplicateContacts(newData);
    const sortedContacts = this.groupAndSortByDateChat(uniqueData);

    // Update state without changing loader state
    this.setState({
      conversationNewData: sortedContacts,
      conversationDataMain: uniqueData
    });

    const selectedConversationId = String(this.getSelectedConversationId() || "");
    const selectedConversationData = uniqueData.find(
      (contact: any) => String(contact?.id) === String(this.state.selectedConversation?.id)
    );
    const latestConversationId = String(
      selectedConversationData?.attributes?.chat_conversation_id ||
      selectedConversationData?.attributes?.twilio_conversation_id ||
      ""
    );
    if (
      selectedConversationData &&
      latestConversationId &&
      selectedConversationId &&
      latestConversationId !== selectedConversationId
    ) {
      this.updateSelectedConversationId(latestConversationId, false);
    }
  }

  handleClickPopOver = (event: any, item: any) => {
    this.setState({ userItem: item });
    this.setState({ anchorEll: event.currentTarget });
  };

  closeModal() {
    this.setState({ teammatesModal: false });
  }

  closeNewContactModal = () => {
    this.setState({ newContactModal: false });
  };

  openNewContactModal = () => {
    this.changeTopNavigation("New Contact");
    this.setState({ newContactModal: true, createNewContactMobile: true, addNewMessageMobile: false});
  };

  openModal() {
    this.setState({ teammatesModal: true });
  }

  handleClosePopOver() {
    this.setState({ anchorEll: null });
  }

  handleAutomationPopOver = () => {
    this.setState({ automationModal: null });
  };

  getUserDetails = () => {
    const headers = {
      "Content-Type": configJSON.commentsContentType,
      Token: localStorage.getItem("authToken"),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.userDetailsApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.dashboardGetUrl
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleAutomationSearch = (event: any) => {
    const query = event.target.value;
    this.setState({ automationSearchQuery: query });
    if (query.length) {
      const results = automationsData.filter((item) =>
        item.name.toLowerCase().includes(query.toLowerCase())
      );
      this.setState({
        autoamtionFilterData: results,
      });
    } else {
      this.setState({ autoamtionFilterData: automationsData });
    }
  };

  handleOptionsApiResponse = (res: any) => {
    if (res.message) {
      this.setState({
        showAlert: true,
        showSuccess: res.message,
      });
    } else {
      this.setState({
        showAlert: true,
        showSuccess: "Something went wrong!",
        errorAlertMessage: true,
      });
    }
    this.setState({
      messageOptionsPopover: false,
    });
    this.closeSnackBar();
  };
  handleMenuOpen = (event: any) => {
    this.setState({ callMenuModal: event.currentTarget });
  };
  
  handleMenuClose = () => {
    this.setState({ callMenuModal: null });
  };

  handleMessageHover = (messageKey: string) => {
    this.setState({ hoveredMessageKey: messageKey });
  };

  handleMessageHoverEnd = () => {
    this.setState({ hoveredMessageKey: "" });
  };

  getMessageReactionStorageKey = (conversation?: any) => {
    const selectedConversation = conversation || this.state.selectedConversation;
    const conversationId = String(selectedConversation?.id || "default");
    return `message_reactions_${conversationId}`;
  };

  loadMessageReactions = (conversation?: any) => {
    if (typeof window === "undefined") return;
    try {
      const storageKey = this.getMessageReactionStorageKey(conversation);
      const storedReactions = window.localStorage.getItem(storageKey);
      if (!storedReactions) {
        if (Object.keys(this.state.messageReactions || {}).length) {
          this.setState({ messageReactions: {} });
        }
        return;
      }

      const parsedReactions = JSON.parse(storedReactions);
      const nextReactions =
        parsedReactions && typeof parsedReactions === "object"
          ? parsedReactions
          : {};
      if (JSON.stringify(nextReactions) !== JSON.stringify(this.state.messageReactions || {})) {
        this.setState({ messageReactions: nextReactions });
      }
    } catch (error) {
      if (Object.keys(this.state.messageReactions || {}).length) {
        this.setState({ messageReactions: {} });
      }
    }
  };

  saveMessageReactions = (reactions: { [key: string]: string }, conversation?: any) => {
    if (typeof window === "undefined") return;
    try {
      const storageKey = this.getMessageReactionStorageKey(conversation);
      window.localStorage.setItem(storageKey, JSON.stringify(reactions));
    } catch (error) {
    }
  };

  openReactionPicker = (event: any, messageKey: string, isSender: boolean = false) => {
    event.stopPropagation();
    const rect = event.currentTarget.getBoundingClientRect();
    const pickerWidth = 248;
    const left = isSender
      ? Math.max(8, rect.right + window.scrollX - pickerWidth)
      : Math.max(8, rect.left + window.scrollX - 8);
    const top = Math.max(8, rect.top + window.scrollY - 10);

    this.setState({
      reactionPickerAnchorEl: event.currentTarget,
      reactionPickerMessageKey: messageKey,
      reactionPickerPosition: { top, left },
    });
  };

  closeReactionPicker = () => {
    this.setState({
      reactionPickerAnchorEl: null,
      reactionPickerMessageKey: "",
      reactionPickerPosition: null,
    });
  };

  addMessageReaction = (emoji: string) => {
    const { reactionPickerMessageKey } = this.state;
    if (!reactionPickerMessageKey) return;

    this.setState((prevState) => {
      const updatedReactions = {
        ...prevState.messageReactions,
        [reactionPickerMessageKey]: emoji,
      };
      this.saveMessageReactions(updatedReactions);
      return {
        messageReactions: updatedReactions,
        reactionPickerAnchorEl: null,
        reactionPickerMessageKey: "",
        reactionPickerPosition: null,
      };
    });
  };

  handleClosePopover = (message: any) => {
    this.setState({
      messageOptionsPopover: false,
      selectedConversation: message,
    });
  };

  closeSnackBar = () => {
    setTimeout(() => {
      this.setState({
        showAlert: false,
        showSuccess: "",
        errorAlertMessage: false,
      });
    }, 3000);
  };

  handleSearch = (e: any) => {
    const query = (e.target.value || "").trim().toLowerCase();
    this.setState({ messageSearchQuery: e.target.value });

    if (!query.length) {
      this.setState({
        conversationNewData: this.groupAndSortByDateChat(this.state.conversationDataMain),
      });
      return;
    }

    const filteredContacts = (this.state.conversationDataMain || []).filter((item: any) => {
      const firstName = (item?.attributes?.first_name || "").toLowerCase();
      const lastName = (item?.attributes?.last_name || "").toLowerCase();
      const fullName = `${firstName} ${lastName}`.trim();
      return (
        firstName.includes(query) ||
        lastName.includes(query) ||
        fullName.includes(query)
      );
    });

    this.setState({
      conversationNewData: this.groupAndSortByDateChat(filteredContacts),
    });
  };

  addChatInteraction(data: {contact: {first_name: string, last_name: string, email: string, Phone: string}}){
    const headerData = {
      "Content-Type": configJSON.commentsContentType,
      Token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.addNewChatContactsApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.initChatEndpoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.commentPOSTAPiMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify({Phone: data.contact.Phone})
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  addContacts(values: any) {
    this.setState({
      createNewContactMobile: false, 
      isCenterSideVisibleForMobileView: true,
      isAddingContact: true
    });
    const data = {
      contact: {
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        Phone: `+${values.phone}`,
      },
    };
    if(this.state.chatType === conversationType[2]){
      return this.addChatInteraction(data)
    }
    const headerData = {
      "Content-Type": configJSON.commentsContentType,
      Token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.addNewContactsApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.userTextsNewAPIEndpoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "Post"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(data)
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  handleDeleteFolder() {
    const headerData = {
      "Content-Type": configJSON.commentsContentType,
      Token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    let url = configJSON.delteFolderEndPoint + this.state.userItem.id;

    this.deleteFolderApiId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      url
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "DELETE"
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  getSelectedConversationId = () => {
    const selected = this.state.selectedConversation;
    return (
      selected?.attributes?.twilio_conversation_id ||
      selected?.attributes?.chat_conversation_id ||
      selected?.attributes?.conversation_id ||
      selected?.twilio_conversation_id ||
      selected?.chat_conversation_id ||
      selected?.conversation_id ||
      ""
    );
  };

  getConversationIdFor = (conversation: any) => {
    if (!conversation) return "";
    return (
      conversation?.attributes?.twilio_conversation_id ||
      conversation?.attributes?.chat_conversation_id ||
      conversation?.attributes?.conversation_id ||
      conversation?.twilio_conversation_id ||
      conversation?.chat_conversation_id ||
      conversation?.conversation_id ||
      ""
    );
  };

  normalizePhone = (value: string = "") => value.replace(/\D/g, "");

  updateSelectedConversationId = (conversationId: string, reloadConversation = false) => {
    if (!conversationId || !this.state.selectedConversation?.id) return null;

    const selected = this.state.selectedConversation;
    const currentConversationId = String(this.getSelectedConversationId() || "");
    const nextConversationId = String(conversationId || "");
    if (!nextConversationId || currentConversationId === nextConversationId) return selected;

    const updatedSelectedConversation = {
      ...selected,
      attributes: {
        ...(selected?.attributes || {}),
        twilio_conversation_id: nextConversationId,
        chat_conversation_id: nextConversationId,
      },
      twilio_conversation_id: nextConversationId,
      chat_conversation_id: nextConversationId,
    };

    const updatedConversationDataMain = (this.state.conversationDataMain || []).map((contact: any) => {
      if (String(contact?.id) !== String(selected?.id)) return contact;
      return {
        ...contact,
        attributes: {
          ...(contact?.attributes || {}),
          twilio_conversation_id: nextConversationId,
          chat_conversation_id: nextConversationId,
        },
        twilio_conversation_id: nextConversationId,
        chat_conversation_id: nextConversationId,
      };
    });

    this.setState({
      selectedConversation: updatedSelectedConversation,
      conversationDataMain: updatedConversationDataMain,
      conversationNewData: this.groupAndSortByDateChat(updatedConversationDataMain),
    });

    if (reloadConversation) {
      this.getConversation(updatedSelectedConversation);
    }

    return updatedSelectedConversation;
  };

  syncConversationIdFromSendResponse = (responseJson: any) => {
    const currentConversationId = String(this.getSelectedConversationId() || "");
    if (!currentConversationId) return null;

    const updatedMap = responseJson?.updated_conversation_ids || {};
    const mappedConversationId =
      updatedMap[currentConversationId] ||
      updatedMap[String(currentConversationId)];

    const fallbackConversationId =
      responseJson?.conversation_id ||
      responseJson?.messages?.[0]?.conversation_id ||
      responseJson?.account?.data?.attributes?.chat_conversation_id ||
      responseJson?.account?.data?.attributes?.twilio_conversation_id;

    const nextConversationId = String(mappedConversationId || fallbackConversationId || "");
    if (!nextConversationId) return null;

    return this.updateSelectedConversationId(nextConversationId, false);
  };

  initializeChatSocket = () => {
    const token = localStorage.getItem("authToken");
    if (!token) return;

    const wsBase = baseURL.replace(/^http/i, "ws");
    this.chatSocket = new WebSocket(`${wsBase}/cable?token=${token}`);
    this.chatSocket.onopen = this.handleChatSocketOpen;
    this.chatSocket.onmessage = this.handleChatSocketMessage;
    this.chatSocket.onclose = this.handleChatSocketClose;
    this.chatSocket.onerror = this.handleChatSocketClose;
  };

  handleChatSocketOpen = () => {
    this.isChatSocketSubscribed = false;
    this.subscribeChatMessagesChannel();
  };

  subscribeChatMessagesChannel = () => {
    if (!this.chatSocket || this.chatSocket.readyState !== WebSocket.OPEN) return;
    const subscribePayload = {
      command: "subscribe",
      identifier: JSON.stringify({ channel: "ChatMessagesChannel" }),
    };
    this.chatSocket.send(JSON.stringify(subscribePayload));
  };

  handleChatSocketMessage = (event: MessageEvent) => {
    try {
      const payload = JSON.parse(event.data);
      if (payload.type === "confirm_subscription") {
        this.isChatSocketSubscribed = true;
        return;
      }

      if (!payload.message || typeof payload.message !== "object") return;
      const data = payload.message;
      const eventType = data.type;
      if (eventType !== "new_message" && eventType !== "delivery_status") return;

      const incomingConversationId = String(
        data.conversation_id || data?.message?.conversation_id || ""
      );
      const selectedConversationId = String(this.getSelectedConversationId() || "");
      const incomingFromPhone = this.normalizePhone(
        String(data?.message?.from || data?.from || "")
      );
      const selectedPhone = this.normalizePhone(
        String(this.state.selectedConversation?.attributes?.full_phone_number || "")
      );

if (eventType === "new_message") {
  // `incomingConversationId` now also checks the nested `message.conversation_id`
  // path (see above) — some real-time payloads (e.g. genuine EU-originated
  // messages) carry it there instead of at the top level, which meant this
  // used to fall through to a stale/empty id and skip the refresh entirely.
  const conversationId =
    Number(incomingConversationId) ||
    this.state.selectedConversation?.conversation?.id ||
    this.state.selectedConversation?.id ||
    this.state.selectedConversation?.last_message?.conversation_id;

  if (conversationId) {
    this.refreshConversationMessages(conversationId);
  }
}
      if (
        eventType === "new_message" &&
        incomingConversationId &&
        selectedConversationId &&
        incomingConversationId === selectedConversationId
      ) {
        this.getConversation(this.state.selectedConversation);
        return;
      }

      if (
        eventType === "new_message" &&
        incomingConversationId &&
        incomingFromPhone &&
        selectedPhone &&
        incomingFromPhone === selectedPhone
      ) {
        this.updateSelectedConversationId(incomingConversationId, true);
      }
    } catch (error) {
      console.error("Failed to parse chat realtime message", error);
    }
  };

  handleChatSocketClose = () => {
    this.isChatSocketSubscribed = false;
    if (this.chatSocketReconnectTimer) clearTimeout(this.chatSocketReconnectTimer);
    this.chatSocketReconnectTimer = setTimeout(() => {
      this.initializeChatSocket();
    }, 3000);
  };

  teardownChatSocket = () => {
    if (this.chatSocketReconnectTimer) {
      clearTimeout(this.chatSocketReconnectTimer);
      this.chatSocketReconnectTimer = null;
    }
    if (this.chatSocket) {
      this.chatSocket.onopen = null;
      this.chatSocket.onmessage = null;
      this.chatSocket.onclose = null;
      this.chatSocket.onerror = null;
      this.chatSocket.close();
      this.chatSocket = null;
    }
  };

  async componentDidMount(): Promise<void> {
    if(window.innerWidth < 950){
      this.topNavigationToDashboard();
    }
    this.getUserChats();
    this.getFolders();
    this.handleIsNewChat();
    this.loadCustomMessageVariables();
    this.initializeMessageProcessor();
    this.initializeChatSocket();
    this.loadMessageReactions();

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", this.handleVisualViewportResize);
      window.visualViewport.addEventListener("scroll", this.handleVisualViewportResize);
    }

    this.observeMobileTopBarHeight();
    this.observeMobileContactHeaderHeight();

    // Clean up any existing duplicates after data is loaded
    setTimeout(() => {
      this.cleanupDuplicateContacts();
    }, 2000);
  }

  async componentWillUnmount(): Promise<void> {
    this.teardownChatSocket();
    if (window.visualViewport) {
      window.visualViewport.removeEventListener("resize", this.handleVisualViewportResize);
      window.visualViewport.removeEventListener("scroll", this.handleVisualViewportResize);
    }
    if (this.mobileTopBarResizeObserver) {
      this.mobileTopBarResizeObserver.disconnect();
    }
    if (this.mobileTopBarObserverRetryTimer) {
      clearTimeout(this.mobileTopBarObserverRetryTimer);
    }
    if (this.mobileContactHeaderResizeObserver) {
      this.mobileContactHeaderResizeObserver.disconnect();
    }
    if (this.mobileContactHeaderObserverRetryTimer) {
      clearTimeout(this.mobileContactHeaderObserverRetryTimer);
    }
    this.setMobileBottomNavHidden(false);
  }

  // On mobile, the on-screen keyboard shrinks `window.visualViewport` without
  // changing `100vh`, which left the fixed send bar floating with a dead gap
  // above the keyboard. Track that shrink so the send bar can hug the keyboard.
  handleVisualViewportResize = () => {
    const viewport = window.visualViewport;
    if (!viewport) {
      return;
    }
    const offset = Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop);
    this.setState({ mobileKeyboardOffset: offset });
    requestAnimationFrame(() => this.scrollToBottom("auto"));
  };

  mobileTopBarResizeObserver: ResizeObserver | null = null;
  mobileTopBarObserverRetryTimer: ReturnType<typeof setTimeout> | null = null;

  // AppLayout renders its own fixed, higher-z-index app bar
  // (NavigationMenuMobile) above every mobile page, including this one — our
  // own contact-info header was also pinned to the true viewport top, so it
  // rendered underneath that app bar and was invisible. Measure the app bar's
  // real (and resizable — it shrinks on scroll) height so our header can sit
  // just below it instead of overlapping it.
  observeMobileTopBarHeight = () => {
    const appBar = document.querySelector(".MuiAppBar-root");
    if (!appBar) {
      this.mobileTopBarObserverRetryTimer = setTimeout(this.observeMobileTopBarHeight, 200);
      return;
    }

    this.setState({ mobileTopBarHeight: appBar.getBoundingClientRect().height });

    this.mobileTopBarResizeObserver = new ResizeObserver((entries) => {
      const height = entries[0]?.contentRect?.height;
      if (typeof height === "number" && height > 0) {
        this.setState({ mobileTopBarHeight: height });
      }
    });
    this.mobileTopBarResizeObserver.observe(appBar);
  };

  mobileContactHeaderResizeObserver: ResizeObserver | null = null;
  mobileContactHeaderObserverRetryTimer: ReturnType<typeof setTimeout> | null = null;

  // This page's own contact-info header (avatar + name) is only in the DOM
  // once a conversation is open, and it unmounts/remounts as conversations
  // change — measure its real height (rather than guessing) so the messages
  // area's top clearance never leaves dead space above the first message.
  observeMobileContactHeaderHeight = () => {
    const header = document.querySelector(".contact-header-bar");
    if (!header) {
      this.mobileContactHeaderObserverRetryTimer = setTimeout(
        this.observeMobileContactHeaderHeight,
        200
      );
      return;
    }

    if (this.mobileContactHeaderResizeObserver) {
      this.mobileContactHeaderResizeObserver.disconnect();
    }

    this.setState({ mobileContactHeaderHeight: header.getBoundingClientRect().height });

    this.mobileContactHeaderResizeObserver = new ResizeObserver((entries) => {
      const height = entries[0]?.contentRect?.height;
      if (typeof height === "number" && height > 0) {
        this.setState({ mobileContactHeaderHeight: height });
      }
    });
    this.mobileContactHeaderResizeObserver.observe(header);
  };

  // AppLayout also renders a persistent bottom tab bar (MobileNavMenu) with
  // an even higher z-index than our send bar, on every mobile page including
  // this one — once the on-screen keyboard properly resizes the viewport,
  // that tab bar re-appears above the keyboard and completely covers our chat
  // input. WhatsApp hides its own bottom tabs once you're inside a specific
  // conversation, so mirror that: hide the shared tab bar while `openInfoModal`
  // (a chat is open) is true on mobile, restore it otherwise.
  setMobileBottomNavHidden = (hidden: boolean) => {
    const bottomNav = document.querySelector<HTMLElement>(".MuiBottomNavigation-root");
    if (bottomNav) {
      bottomNav.style.display = hidden ? "none" : "";
    }
  };

  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevState.openInfoModal !== this.state.openInfoModal) {
      this.setMobileBottomNavHidden(this.state.openInfoModal && window.innerWidth < 1150);
    }

    if (!prevState.hasSelectedAtLeastOnce && this.state.hasSelectedAtLeastOnce) {
      // The contact-info header just mounted for the first time (or after
      // being unmounted) — re-measure it now that it exists in the DOM.
      this.observeMobileContactHeaderHeight();
    }

    // if (prevState.chatSelectedContact?.length < this.state.chatSelectedContact?.length) {
    //   const container = this.chatSectionRef.current;
    //   if (container) {
    //     container.scrollTo({
    //       top: container.scrollHeight,
    //       behavior: 'smooth'
    //     });
    //   }
    // }
    // Conversation change logic
    if (prevState.selectedConversation !== this.state.selectedConversation) {
      this.updateMessageVariableContext(
        this.state.selectedConversation,
        this.state.userDetails
      );
      this.loadMessageReactions(this.state.selectedConversation);
    }

    // Auto-scroll to the latest message, same as WhatsApp/Instagram:
    // - instantly when a conversation is opened / finishes loading
    // - smoothly when a new message is appended while already viewing the chat
    const conversationChanged =
      prevState.selectedConversation?.id !== this.state.selectedConversation?.id;
    const justFinishedLoading = prevState.isLoading && !this.state.isLoading;
    const messagesGrew =
      (prevState.chatSelectedContact?.length || 0) <
      (this.state.chatSelectedContact?.length || 0);

    if (conversationChanged || justFinishedLoading || messagesGrew) {
      const behavior = conversationChanged || justFinishedLoading ? "auto" : "smooth";
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.scrollToBottom(behavior);
        });
      });
    }

    // Template fallback logic
    if (this.state.isNewMessage && !this.state.newMessage) {
      const templateData = localStorage.getItem("automationTemplate");
  
      if (templateData) {
        try {
          const template = JSON.parse(templateData);
          const templateContent = template.content || "";
  
          if (templateContent) {
            this.setState({ newMessage: templateContent });
            localStorage.removeItem("automationTemplate");
          }
        } catch (e) {
          console.error("Error parsing template data:", e);
          localStorage.removeItem("automationTemplate");
        }
      }
    }
  }

  topNavigationToDashboard = (name: string = "All Message") => {
    const msg = new Message(getName(MessageEnum.NavigationMobileData));
    msg.addData(getName(MessageEnum.NavigationMobileData), {backArrowFunction: this.handleRedirect, name: name, icon: ChatNavIcon, dropdownFunction: this.dropdownFunction});
    this.send(msg);
  }

  changeTopNavigation = (name: string) => {
    const msg = new Message(getName(MessageEnum.NavigationMobileData));
    msg.addData(getName(MessageEnum.NavigationMobileData), {backArrowFunction: this.handleBackNavigation, name: name, icon: ChatNavIcon, dropdownFunction: this.dropdownFunction});
    this.send(msg);
  }

  handleBackNavigation = (name: string) => {
    if(name.includes('Text') || name.includes("Chat") || name.includes("All") || name.includes("Direct") || name.includes("New message")){
      if(this.state.isCenterSideVisibleForMobileView || this.state.isRightSideVisibleForMobileView || this.state.addNewMessageMobile){
        this.topNavigationToDashboard(this.state.chatType);
      }
      this.setState({isCenterSideVisibleForMobileView: true,
                     isRightSideVisibleForMobileView: false, 
                     isLeftSideVisibleForMobileview: false, 
                     addNewMessageMobile: false,
                     createNewContactMobile: false});
    } else if(name.includes('New Contact')){
      this.changeTopNavigation("New message");
      this.setState({isCenterSideVisibleForMobileView: false, createNewContactMobile: false, addNewMessageMobile: true});
    }
  }

  dropdownFunction = () => {
    this.setState({
      isLeftSideVisibleForMobileview: !this.state.isLeftSideVisibleForMobileview, 
      isCenterSideVisibleForMobileView: !this.state.isCenterSideVisibleForMobileView,
      isRightSideVisibleForMobileView: false
    })
  }

  handleRedirect = () => {
    const msg = new Message(getName(MessageEnum.NavigationMessage));
    msg.addData(getName(MessageEnum.NavigationTargetMessage), "Dashboard");
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  }

  showMoreFeature = () => {
    this.setState({isDocCameraAutoVisible: !this.state.isDocCameraAutoVisible})
  }

  handleIsNewChat = () => {
    const params = new URLSearchParams(window.location.search)
    const isNewChat = params.get("new-chat")
    if(isNewChat) {
      // Always call handleNewMessage first to set up the UI
      this.handleNewMessage()
      
      // Then check for template data from automation templates
      const templateData = localStorage.getItem('automationTemplate')
      if(templateData) {
        try {
          const template = JSON.parse(templateData)
          const templateContent = template.content || ""
          if(templateContent) {
            // Use multiple timeouts to ensure the state is set after component renders
            // First attempt after a short delay
            setTimeout(() => {
              this.setState({ newMessage: templateContent }, () => {
                // Clear the template data after successfully setting it
                localStorage.removeItem('automationTemplate')
              })
            }, 200)
            
            // Fallback: Try again after a longer delay in case the first attempt didn't work
            setTimeout(() => {
              if(!this.state.newMessage && localStorage.getItem('automationTemplate')) {
                const retryTemplateData = localStorage.getItem('automationTemplate')
                if(retryTemplateData) {
                  try {
                    const retryTemplate = JSON.parse(retryTemplateData)
                    const retryContent = retryTemplate.content || ""
                    if(retryContent) {
                      this.setState({ newMessage: retryContent })
                      localStorage.removeItem('automationTemplate')
                    }
                  } catch (e) {
                    console.error('Error parsing retry template data:', e)
                    localStorage.removeItem('automationTemplate')
                  }
                }
              }
            }, 500)
          } else {
            localStorage.removeItem('automationTemplate')
          }
        } catch (e) {
          console.error('Error parsing template data:', e)
          localStorage.removeItem('automationTemplate')
        }
      } else {
      }
    }
  }

  assignFolderToTeamate(teammate: any) {
    const data = {
      chat_folder: {
        teammate_id: teammate.id,
      },
    };
    this.updateFolder(data);
  }

  getTeammates() {
    const headerData = {
      "Content-Type": configJSON.commentsContentType,
      Token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getTeamMatesApiId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.teamMatesEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  getUserChats() {
    this.setState({isLoaderShow: true});
    const headerData = {
      "Content-Type": configJSON.commentsContentType,
      Token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getUserChatsApiId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.userChatsConversationsEndPoint}?page=1&per_page=20`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  refreshConversationMessages(conversationId?: number) {
    const id =
      conversationId ||
      this.state.selectedConversation?.conversation?.id ||
      this.state.selectedConversation?.id ||
      this.state.selectedConversation?.last_message?.conversation_id;

    if (!id) return;

    const headerData = {
      "Content-Type": configJSON.commentsContentType,
      token: localStorage.getItem("authToken"),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.refreshConversationMessagesApiId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.getChatMessageNewAPIEndPoint}/${id}/messages`
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  getFolders() {
    const headerData = {
      "Content-Type": configJSON.commentsContentType,
      Token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getFoldersApiId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getFoldersEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  getContacts(searchTerm: string) {
    // keep local input responsive even before results arrive
    this.setState({ selectedContact: {}, contactSearchQuery: searchTerm });
    let url = configJSON.contactsSearchEndPoint + searchTerm;
    const headerData = {
      "Content-Type": configJSON.commentsContentType,
      Token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getContactsApiId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      url
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  createUserFolder() {
    const data = {
      chat_folder: {
        name: "Folder " + (this.state.userFolders.length + 1),
      },
    };

    const headerData = {
      "Content-Type": configJSON.commentsContentType,
      token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.createFoldersApiId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.createFoldersEndpoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(data)
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  handleCameraClick = (e: any) => {
    const formData = new FormData();
    formData.append(
      "message[conversation_id]",
      this.getConversationIdFor(this.state.selectedConversation),
    );
    formData.append("message[body]", e.target.files[0]);

    const headersData = {
      "Content-Type": configJSON.sendNewMessageContentType,
      token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.cameraAttachmentsApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headersData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      this.state.selectedConversation.type === "ChatContact" ? configJSON.sendChatMessageEndPoint : configJSON.sendMessageEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(formData)
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  };

  updateFolder(data: any) {
    const headerData = {
      "Content-Type": configJSON.commentsContentType,
      token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    let url = configJSON.updateFolderEndPoint + this.state.userItem.id;

    this.updateFolderApiId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      url
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "PUT"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(data)
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  openEditFolderModal = () => {
    const folderName = this.state.userItem?.attributes?.name || "";
    this.setState({
      editFolderModal: true,
      editFolderName: folderName,
    });
    this.handleClosePopOver();
  };

  closeEditFolderModal = () => {
    this.setState({
      editFolderModal: false,
      editFolderName: "",
    });
  };

  handleEditFolderNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      editFolderName: e.target.value,
    });
  };

  handleSaveFolderName = () => {
    const trimmedName = this.state.editFolderName.trim();
    if (trimmedName && trimmedName !== this.state.userItem?.attributes?.name) {
      const data = {
        chat_folder: {
          name: trimmedName,
        },
      };
      this.updateFolder(data);
    } else {
      this.closeEditFolderModal();
    }
  };

  sendNewConversation() {
    const data = {
      contact: {
        first_name: this.state.selectedConversation.attributes.first_name,
        last_name: this.state.selectedConversation.attributes.last_name,
        email: this.state.selectedConversation.attributes.email,
        full_phone_number:
          this.state.selectedConversation.attributes.full_phone_number,
      },
    };

    const headerData = {
      "Content-Type": configJSON.newMessageContentType,
      token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.newConversationApiId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.createConversationEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(data)
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  sendNewMessage() {
  this.setState({ newOrOldUserSelected: false });

  if (!this.state.newMessage.trim()) {
    return;
  }

  if (this.state.isNewMessage) {
    this.sendNewConversation();
    return;
  }

  // Process variables
  let processedMessage = this.state.newMessage;

  const firstName =
    this.state.userDetails?.attributes?.first_name || "";
  const lastName =
    this.state.userDetails?.attributes?.last_name || "";

  const businessName =
    this.state.userDetails?.attributes?.business_name ||
    this.state.userDetails?.attributes?.location_name ||
    this.state.userDetails?.attributes?.name ||
    this.state.userDetails?.attributes?.full_name ||
    (firstName && lastName
      ? `${firstName} ${lastName}`.trim()
      : firstName || lastName || "Business Name");

  // New API customer name
  const receiverFirstName =
    this.state.selectedConversation?.customer?.name || "";

  const context: SimpleMessageContext = {
    contactName: receiverFirstName,
    contactFullName: receiverFirstName,
    businessName,
    businessContactName: firstName || "Business Contact",
    businessContactFirstName: firstName || "Business Contact",
    businessContactFullName:
      `${firstName} ${lastName}`.trim() || "Business Contact",
    businessPhone:
      this.state.userDetails?.attributes?.phone_number || "",
    businessEmail:
      this.state.userDetails?.attributes?.email || "",
    uniqueAuthId:
      this.state.userDetails?.attributes?.unique_auth_id || "",
  };

  processedMessage = processMessageVariables(
    this.state.newMessage,
    context
  );

  // Conversation Id
  const conversationId = this.state.selectedConversation?.id || this.state.conversationIdNew;

  const body = {
    content: processedMessage,
  };

  const headerData = {
    "Content-Type": "application/json",
    Accept: "application/json",
    token: localStorage.getItem("authToken"),
  };

  const requestMessage = new Message(
    getName(MessageEnum.RestAPIRequestMessage)
  );

  this.newMessageApiId = requestMessage.messageId;

  requestMessage.addData(
    getName(MessageEnum.RestAPIRequestHeaderMessage),
    JSON.stringify(headerData)
  );

  requestMessage.addData(
    getName(MessageEnum.RestAPIResponceEndPointMessage),
    `${configJSON.sendMessageNewAPIEndPoint}/${conversationId}/messages`
  );

  requestMessage.addData(
    getName(MessageEnum.RestAPIRequestMethodMessage),
    "POST"
  );

  requestMessage.addData(
    getName(MessageEnum.RestAPIRequestBodyMessage),
    JSON.stringify(body)
  );

  runEngine.sendMessage(requestMessage.id, requestMessage);

  // Optimistic UI
  // Carry over the same device (sms/imsg) as the most recent message in this
  // conversation so the bubble doesn't render blue and then flip to green
  // once the real message comes back from the server with its true device.
  const lastKnownDevice = [...this.state.chatSelectedContact]
    .reverse()
    .find((chat: any) => chat.device)?.device;

  const newChatObject = {
    id: `temp-${Date.now()}`,
    content: processedMessage,
    created_at: new Date().toISOString(),
    // Must match the backend model name the render logic checks
    // (`chat.sender_type === "AccountBlock::Account"`) — "Account" never
    // matched, so this optimistic bubble rendered as if it were the other
    // person's message until the follow-up refresh replaced it.
    sender_type: "AccountBlock::Account",
    sender_id: this.state.userDetails?.id || localStorage.getItem("current_user_id"),
    _direction: "sender",
    device: lastKnownDevice || "sms",
  };

  // Update last message in conversation list
  this.updateConversationListWithLastMessage(processedMessage);

  this.setState(
    (prevState: any) => ({
      chatSelectedContact: [
        ...prevState.chatSelectedContact,
        newChatObject,
      ],
      newMessage: "",
    }),
    () => {
      this.scrollToBottom("smooth");
    }
  );

  return requestMessage.messageId;
}

  updateConversationListWithLastMessage = (messageText: string) => {
    if (!this.state.selectedConversation || !this.state.selectedConversation.id) {
      return;
    }

    // Update conversationDataMain
    const updatedConversationDataMain = this.state.conversationDataMain.map((contact: any) => {
      if (contact.id === this.state.selectedConversation.id) {
        return {
          ...contact,
          attributes: {
            ...contact.attributes,
            last_message: messageText,
            last_text: messageText,
            message_text: messageText,
            latest_message: messageText,
            last_interaction_date: new Date().toISOString()
          }
        };
      }
      return contact;
    });

    // Re-sort and re-group the conversations
    const sortedContacts = this.groupAndSortByDateChat(updatedConversationDataMain);

    // Update state
    this.setState({
      conversationNewData: sortedContacts,
      conversationDataMain: updatedConversationDataMain
    });
  };

  handleMessageCategory(chatType: string, chatCircle: any) {
    this.topNavigationToDashboard(chatType);
    this.setState({
      isLeftSideVisibleForMobileview: false, 
      isCenterSideVisibleForMobileView: true,
      isRightSideVisibleForMobileView: false,
      addNewMessageMobile: false,
      createNewContactMobile: false
    })
    this.setState({ chatCircle: chatCircle, chatType: chatType });
    if (chatType === "Text") {
      this.filterMessages("sms_contacts");
    }
    if (chatType === "Chat") {
      this.filterMessages("chat_contacts");
    }
    if (chatType === "Direct Post") {
      this.filterMessages("direct_post_contacts");
    }
    if (chatType === "All Messages") {
      this.getUserChats();
    }
  }

  filterMessages = (chatType: string) => {
    this.setState({ chatTypeAPI: chatType, isLoaderShow: true });
    const body = {
      type: chatType,
    };
    const headerData = {
      "Content-Type": configJSON.commentsContentType,
      Token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.filterMessagesApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.userChatsEndPoint + "/filters"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "Post"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(body)
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  };

  getConversation(value: any) {
    this.changeTopNavigation(this.state.chatType);
      // Conversation Id\
      console.log("value123123", value);
    const conversationId = value?.last_message?.conversation_id || this.state.conversationIdNew;
console.log("conversationId123123", conversationId);
    this.setState({ 
      newOrOldUserSelected: false, 
      isNewMessage: false, 
      selectedConversation: value, 
      isLoading: true,
      isFetchingChat: true,
      hasSelectedAtLeastOnce: true,
      isRightSideVisibleForMobileView: true,
      isCenterSideVisibleForMobileView: false,
    });

    const headerData = {
      "Content-Type": configJSON.newMessageContentType,
      token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getConversationUserId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.getChatMessageNewAPIEndPoint}/${conversationId}/messages`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  closeNewMssage = () => {
    this.setState({isNewMessage:false})
  }

  hanldeUserContact(contact: any) {
    this.setState({ showContcatCard: false, selectedContact: contact, addNewMessageMobile: false, contactSearchQuery: contact?.attributes?.first_name || "" });
    this.checkIfContactIsPresent(contact);
  }

  handleAutomationClick(e: any) {
    this.setState({ automationModal: e.currentTarget });
  }

  checkIfContactIsPresent(contact: any) {
    this.setState({tempAddingNewContact: contact});
    let matchedContact = this.state.conversationDataMain.find((item: any) => item.id === contact.attributes.id);
    
    if(contact.attributes.twilio_conversation_id || contact.attributes.chat_conversation_id){
      this.getConversation(contact)
      this.setState({
        selectedConversation: contact,
        isNewMessage: false,
        newOrOldUserSelected: true
      });
    } else if(matchedContact){
      this.getConversation(matchedContact)
      this.setState({
        selectedConversation: matchedContact,
        isNewMessage: false,
        newOrOldUserSelected: true
      });
    } else {
      this.addContacts({
        first_name: contact.attributes.first_name,
        last_name: contact.attributes.last_name,
        email: contact.attributes.email,
        phone: contact.attributes.full_phone_number,
      })
    }
  }

  handleNewMessage() {
    this.changeTopNavigation("New message")
    this.setState({ isNewMessage: true, selectedContact: {}, addNewMessageMobile: true, isCenterSideVisibleForMobileView: false, contactSearchQuery: ""});
  }

  handleFilterSelect(name: string){
    this.setState({selectedFilterName: name, filterAnchorEl: null})
  }

  // Message Variables Processing Methods
  initializeMessageProcessor = () => {
    const { customMessageVariables, messageVariableContext } = this.state;
    const allVariables = [...DEFAULT_MESSAGE_VARIABLES, ...customMessageVariables];
    
    this.setState({
      messageProcessor: new MessageVariableProcessor(allVariables, messageVariableContext)
    });
  }

  updateMessageVariableContext = (contact?: any, business?: any) => {
    const context: MessageVariableContext = {
      contact: contact ? {
        id: contact.id || contact.attributes?.id,
        first_name: contact.attributes?.first_name || contact.first_name,
        last_name: contact.attributes?.last_name || contact.last_name,
        full_name: contact.attributes?.full_name || contact.full_name,
        phone_number: contact.attributes?.phone_number || contact.phone_number,
        email: contact.attributes?.email || contact.email
      } : undefined,
      business: business ? {
        id: business.id || business.attributes?.id,
        name: business.attributes?.name || business.name,
        contact_first_name: business.attributes?.contact_first_name || business.contact_first_name,
        contact_last_name: business.attributes?.contact_last_name || business.contact_last_name,
        contact_full_name: business.attributes?.contact_full_name || business.contact_full_name,
        office_number: business.attributes?.office_number || business.office_number,
        email: business.attributes?.email || business.email
      } : undefined,
      system: {
        current_user_id: localStorage.getItem('userId') || '',
        current_business_id: localStorage.getItem('businessId') || '',
        timestamp: new Date().toISOString()
      }
    };

    this.setState({ messageVariableContext: context }, () => {
      this.initializeMessageProcessor();
    });
  }

  processMessageWithVariables = (message: string): string => {
    const { messageProcessor } = this.state;
    
    if (messageProcessor) {
      return messageProcessor.processMessage(message);
    }
    
    return message;
  }

  loadCustomMessageVariables = () => {
    // Load custom variables from localStorage or API
    const savedVariables = localStorage.getItem('customMessageVariables');
    if (savedVariables) {
      try {
        const customVariables = JSON.parse(savedVariables);
        this.setState({ customMessageVariables: customVariables }, () => {
          this.initializeMessageProcessor();
        });
      } catch (error) {
        console.error('Error loading custom message variables:', error);
      }
    }
  }

  saveCustomMessageVariables = (variables: MessageVariable[]) => {
    localStorage.setItem('customMessageVariables', JSON.stringify(variables));
    this.setState({ customMessageVariables: variables }, () => {
      this.initializeMessageProcessor();
    });
  }

  addCustomMessageVariable = (variable: MessageVariable) => {
    const { customMessageVariables } = this.state;
    const updatedVariables = [...customMessageVariables, variable];
    this.saveCustomMessageVariables(updatedVariables);
  }

  updateCustomMessageVariable = (variableId: string, updatedVariable: MessageVariable) => {
    const { customMessageVariables } = this.state;
    const updatedVariables = customMessageVariables.map(v => 
      v.id === variableId ? updatedVariable : v
    );
    this.saveCustomMessageVariables(updatedVariables);
  }

  deleteCustomMessageVariable = (variableId: string) => {
    const { customMessageVariables } = this.state;
    const updatedVariables = customMessageVariables.filter(v => v.id !== variableId);
    this.saveCustomMessageVariables(updatedVariables);
  }

  // Enhanced send message method with variable processing
  sendNewMessageWithVariables = () => {
    const { newMessage, messageProcessor } = this.state;
    
    if (newMessage.length > 0) {
      let processedMessage = newMessage;
      
      // Process message variables if processor is available
      if (messageProcessor) {
        processedMessage = messageProcessor.processMessage(newMessage);
      }
      
      // Update the message in state with processed content
      this.setState({ newMessage: processedMessage }, () => {
        // Call the original send method
        this.sendNewMessage();
      });
    }
  }

  // Document upload functionality
  handleDocumentUpload = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.pdf,.doc,.docx,.txt,.xlsx,.xls,.ppt,.pptx';
    input.multiple = false;
    
    input.onchange = (e: any) => {
      const file = e.target.files[0];
      if (file) {
        this.uploadDocument(file);
      }
    };
    
    input.click();
  }

  // Camera/Image upload functionality
  handleCameraUpload = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*,video/*';
    input.multiple = false;
    
    input.onchange = (e: any) => {
      const file = e.target.files[0];
      if (file) {
        this.uploadMedia(file);
      }
    };
    
    input.click();
  }

  // Upload document file
  uploadDocument = (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('message_id', this.state.selectedConversation.id || '');
    
    // Show loading state
    this.setState({ isLoading: true });
    
    // Here you would typically make an API call to upload the document
    // For now, we'll just show a success message
    setTimeout(() => {
      this.setState({ 
        isLoading: false,
        showSuccess: `Document "${file.name}" uploaded successfully!`
      });
    }, 1000);
  }

  // Upload media file (image/video)
  uploadMedia = (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('message_id', this.state.selectedConversation.id || '');
    
    // Show loading state
    this.setState({ isLoading: true });
    
    // Here you would typically make an API call to upload the media
    // For now, we'll just show a success message
    setTimeout(() => {
      this.setState({ 
        isLoading: false,
        showSuccess: `Media "${file.name}" uploaded successfully!`
      });
    }, 1000);
  }
}
// Customizable Area End
